import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent';
import './CommentCard.scss';

class CommentCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { menu: null };
  }

  handleSeparateTimeDate(dateTime) {
    if (dateTime) {
      let d = new Date(dateTime);
      let date = d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear().toString().substr(-2);

      let hours = d.getHours();
      let meridiem = hours >= 12 ? 'pm' : 'am';
      if (hours == 0) {
        hours = 12;
      } else if (hours > 12) {
        hours -= 12;
      }
      let minutes = d.getMinutes();
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      let time = hours + ':' + minutes + ' ' + meridiem;
      return { time: time, date: date };
    } else {
      return { date: 'n/a', time: 'n/a' };
    }
  }

  render() {
    const { comment } = this.props;

    const user = comment.user;

    let userName = user
      ? user.name ? user.name : user.first_name + ' ' + user.last_name
      : '';
    let profileImage = user && user.profile_image;
    let userImage = null;
    if (profileImage) {
      userImage = (
        <img className="profile-image" alt="User" src={profileImage} />
      );
    } else if (user) {
      const initials =
        user.first_name.substr(0, 1).toUpperCase() +
        user.last_name.substr(0, 1).toUpperCase();
      userImage = (
        <div className="default-user-image-container">
          <div className="default-user-image" />
          <div className="user-initials">{initials}</div>
        </div>
      );
    }

    const dateTime = this.handleSeparateTimeDate(comment.created_at);

    return (
      <div className="completion-step-comment-card">
        {userImage}
        <div className="comment">
          <div className="user-name">{userName + (comment.caption ? ' | ' + comment.caption : '')}</div>
          <div className="comment-body">{comment.body}</div>
        </div>
        <div className="comment-date-time">
          <div className="date-time">{dateTime.date}</div>
          <div className="date-time">{dateTime.time}</div>
        </div>
      </div>
    );
  }
}

export default CommentCard;



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepComments/CommentCard/index.js